import { Grid } from "@mui/material";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import CustomTextField from "../../../../../components/CustomTextField";
import useAuth from "../../../../../hooks/useAuth";
const BankDetails = (props) => {
  const { user } = useAuth();
  const { validationFields } = props;
  const {
    formState: { errors },
    control,
  } = useFormContext();

  const { t } = useTranslation();

  return (
    <Grid container spacing={12} className="row" pt={8} sx={{ paddingLeft: "16px" }}>
      <Grid item md={4}>
        <CustomTextField
          label={t("account_name")}
          name="bankAccountName"
          type="text"
          my={2}
          control={control}
          fullWidth
          variant="outlined"
          errors={errors}
          fields={validationFields}
        />
      </Grid>
      <Grid item md={4}>
        <CustomTextField
          label={t("account_number")}
          name="bankAccountNumber"
          type="text"
          my={2}
          control={control}
          fullWidth
          variant="outlined"
          errors={errors}
          fields={validationFields}
        />
      </Grid>
      <Grid item md={4}>
        <CustomTextField
          label={t("ifsc_code")}
          name="bankIfscCode"
          type="text"
          my={2}
          control={control}
          fullWidth
          variant="outlined"
          errors={errors}
          fields={validationFields}
        />
      </Grid>
      <Grid item md={4}>
        <CustomTextField
          label={t("bank_branch")}
          name="bankBranch"
          type="text"
          my={2}
          control={control}
          fullWidth
          variant="outlined"
          errors={errors}
          fields={validationFields}
        />
      </Grid>
    </Grid>
  );
};

export default BankDetails;
